import { IDS } from '../../settings-action-id.constants';
import {TYPES} from '../../settings-action-type.constants';
import {TYPES as ACC_TYPES} from '../../../accreditation-action-type.constants';
import {TAB_DISABLE} from '../../../../../common/tabs/tabs.constants';
import * as Actions from '../requirements.actions';
import * as AccreditationActions from '../../../accreditation.actions';

/**
 * Creates a new RequirementDetailsController.
 * @class
 */
class RequirementDetailsController {
    constructor($ngRedux, $state, $scope, $mdDialog, $filter, NavigationService, Notifier) {
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.$filter = $filter;
        this.NavigationService = NavigationService;
        this.Notifier = Notifier;
    }

    $onInit() {
        this.identifier     = IDS.accSettings;
        this.statePath      = '';
        this.unsubscribe    = this.$ngRedux.connect( state => {
            const requirementDetails = state.accreditation.accSettings.requirementDetails;
            const frameworkDetails = state.accreditation.accSettings.frameworkDetails;
            return {
                requirementDetails,
                title:              requirementDetails?.nodeName || this.title,
                treeLevel:          requirementDetails?.level,
                requirementId:      requirementDetails?.id,
                sectionName:        requirementDetails?.name,
                sectionPrefix:      requirementDetails?.prefix,
                sectionSiblings:    requirementDetails?.siblings,
                modulePrefixInputSelect: requirementDetails?.modulePrefixInputSelect,
                modulePrefix:       requirementDetails?.modulePrefix,
                isAddingNewNode:    !!requirementDetails?.numberInputSelect,
                isAddingMainSection:!!requirementDetails?.modulePrefixInputSelect,

                schemeId:   frameworkDetails?.id,
                schemeCode: frameworkDetails?.code,

                digits: {
                    level1_num_format: frameworkDetails?.level1_num_format,
                    level2_num_format: frameworkDetails?.level2_num_format,
                    level3_num_format: frameworkDetails?.level3_num_format,
                }
            };
        }, { ...AccreditationActions, ...Actions })(this);
    }

    onCreateChildNodeBtn() {
        let key;
        switch(this.treeLevel) {
            case 1: key = 'ADD_SUB_SECTION'; break;
            case 2: key = 'ADD_3RD_LEVEL_SUB_SECTION'; break;
        }
        this.title = this.$filter('translate')(`ACCREDITATION.SETTINGS.REQUIREMENTS.${key}`)

        const {numberInputSelect, formattedNumberInputSelect} = this.getFormatedNumberInputSelect();

        this.$ngRedux.dispatch({
            type:   TYPES.REQUIREMENT_DETAILS_REFRESH,
            id:     IDS.accreditationSettingsRequirementDetails,
            data:   {
                id:                 this.requirementId,
                number:             numberInputSelect[0].value,
                numberInputSelect:  formattedNumberInputSelect,
                schemeCode:         this.schemeCode,
            }
        });
    }

    getFormatedNumberInputSelect() {
        const modulePrefix = this.modulePrefix || '';
        const sectionPrefix = this.sectionPrefix ? `${this.sectionPrefix}.` : modulePrefix || '';
        const numberInputSelect = [];
        for(let i = 1; i < 100; i++) {
            if(this.sectionSiblings.includes(`${modulePrefix}${i}`) === false) {
                numberInputSelect.push({
                    label: `${sectionPrefix}${i}`,
                    value: i,
                });
            }
        }
        const formattedNumberInputSelect = numberInputSelect.map(item => {
            const sectionsArr = item.label.split('.')
            const digitsArr = Object.values(this.digits)
            const formattedNumber = sectionsArr.map((number, index) => {
                switch (parseInt(digitsArr[index]))
                {
                    case 9:  return (parseInt(number) + 9).toString(36);
                    case 8:  return (parseInt(number) + 9).toString(36).toUpperCase();
                    default: return number.padStart(digitsArr[index], '0')
                }

            })
            return {
                value: `${modulePrefix}${item.value}`,
                label: formattedNumber.join('.')
            }
        });
        return {numberInputSelect, formattedNumberInputSelect};
    }

    onModulePrefixChange({input}) {
        const {numberInputSelect, formattedNumberInputSelect} = this.getFormatedNumberInputSelect();
        this.$ngRedux.dispatch({
            type:   TYPES.REQUIREMENT_DETAILS_REFRESH,
            id:     IDS.accreditationSettingsRequirementDetails,
            data:   {
                id:                     this.requirementId,
                number:                 formattedNumberInputSelect[0].value,
                numberInputSelect:      formattedNumberInputSelect,
                modulePrefixInputSelect:this.modulePrefixInputSelect,
                modulePrefix:           input,
                schemeCode:             this.schemeCode,
                siblings:               this.sectionSiblings,
            }
        });
    }

    onSubmit() {
        this.$scope.$broadcast('show-errors-check-validity', '$ctrl.detailsForm');
        if (this.detailsForm.$valid) {
            if (this.isAddingNewNode) {
                this.addFrameworkRequirement({
                    ...this.requirementDetails,
                    numberInputSelect: undefined,
                    modulePrefixInputSelect: undefined,
                    scheme_id: this.schemeId,
                    parent_id: this.requirementId,
                }).then(() => {
                    this.fetchFrameworkRequirementsTree(this.schemeCode);
                    this.$ngRedux.dispatch({
                        type: ACC_TYPES.SIMPLE_STD_TREE_UNSELECT_ALL,
                    });
                });
            } else {
                this.updateFrameworkRequirementDetails({
                    ...this.requirementDetails,
                    numberInputSelect: undefined,
                    modulePrefixInputSelect: undefined,
                }).then(() => {
                    this.title = `${this.sectionPrefix} ${this.sectionName}`;
                    this.fetchFrameworkRequirementsTree(this.schemeCode);
                })
            }
        }
        else this.Notifier.error('COMMON.FIELDS_REQUIRED');
    }

    onDeleteBtn() {
        const confirm = this.$mdDialog.confirm()
            .title(this.$filter('translate')('COMMON.CONFIRM_DIALOG.ARE_YOU_SURE'))
            .textContent(this.$filter('translate')('ACCREDITATION.SETTINGS.REQUIREMENTS.CONFIRM_DIALOG_CONTENT'))
            .ariaLabel(this.$filter('translate')('ACCREDITATION.SETTINGS.REQUIREMENTS.CONFIRM_DIALOG_LABEL'))
            .ok(this.$filter('translate')('COMMON.CONFIRM_DIALOG.YES'))
            .cancel(this.$filter('translate')('COMMON.CONFIRM_DIALOG.NO'));

        this.dialog = this.$mdDialog.show(confirm).then(() => {
            this.removeFrameworkRequirement(this.requirementId).then( () => {
                this.fetchFrameworkRequirementsTree(this.schemeCode).then(() => {
                    this.$ngRedux.dispatch({ // clear requirementDetails to hide details
                        type: ACC_TYPES.SIMPLE_STD_TREE_UNSELECT_ALL,
                    });
                })
            })
        })
    }

    $onDestroy() {
        this.unsubscribe();
        if (this.dialog)
            this.$mdDialog.hide(this.dialog);
    }
}

RequirementDetailsController.$inject = ['$ngRedux', '$state', '$scope', '$mdDialog', '$filter', 'NavigationService', 'Notifier']

export const requirementDetails = {
    bindings: {
        title: '<',
        tab: '<',
    },
    controller: RequirementDetailsController,
    template: require('./requirement-details.html')
}
